import React from "react";

// Page-specific JSON-LD: FAQPage + Service.
// Injected once on landing page mount.
const FAQ_ITEMS = [
    {
        q: "Faut-il un statut d'entreprise pour rejoindre CapDistrib ?",
        a: "Oui. Un statut professionnel est requis (entreprise individuelle, micro-entreprise, société). Si tu n'en as pas encore, on t'oriente pendant l'entretien de qualification.",
    },
    {
        q: "Combien de temps faut-il consacrer à l'activité ?",
        a: "Cela dépend du niveau choisi. En Apporteur l'activité est ponctuelle. En Business Partner compte quelques heures par semaine. En Master Partner c'est une activité commerciale principale.",
    },
    {
        q: "Quelle est la différence entre Apporteur et Business Partner ?",
        a: "L'Apporteur introduit un réseau et touche une commission sur le volume. Le Business Partner signe le réseau, l'accompagne et fait grandir le catalogue actif. La commission est plus élevée et récurrente.",
    },
    {
        q: "Puis-je évoluer d'un niveau à l'autre ?",
        a: "Oui. L'évolution est naturelle : beaucoup de Business Partners démarrent en Apporteur. Le passage en Master Partner se fait sur invitation, selon le volume animé.",
    },
    {
        q: "Comment sont calculées les commissions ?",
        a: "La commission est calculée sur la marge nette générée par le volume réel des réseaux. Plus le volume est élevé et plus le mix produit est diversifié, plus la commission est importante.",
    },
    {
        q: "Quand suis-je payé ?",
        a: "Les commissions sont calculées mensuellement et versées le mois suivant, après facturation par ta structure professionnelle. Tout est automatisé via l'espace partenaire.",
    },
    {
        q: "Les revenus sont-ils garantis ?",
        a: "Non. CapDistrib ne garantit pas de revenus fixes. La commission dépend du volume réel généré et du mix catalogue effectif. C'est une activité commerciale, pas un salaire.",
    },
];

export default function SeoSchemas() {
    const faqSchema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: FAQ_ITEMS.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: {
                "@type": "Answer",
                text: f.a,
            },
        })),
    };

    const serviceSchema = {
        "@context": "https://schema.org",
        "@type": "Service",
        serviceType: "Programme partenaire de distribution digitale B2B",
        provider: {
            "@type": "Organization",
            name: "CapDistrib",
            url: "https://capdistrib.com/",
        },
        areaServed: ["FR", "EU"],
        description:
            "Programme partenaire B2B permettant à des indépendants qualifiés de distribuer des produits digitaux (recharges mobiles, eSIM, gift cards, gaming, services) auprès de leurs réseaux et de percevoir une commission récurrente.",
        offers: [
            {
                "@type": "Offer",
                name: "Apporteur",
                description:
                    "Niveau 1 — Identification et introduction de réseaux B2B qualifiés.",
            },
            {
                "@type": "Offer",
                name: "Business Partner",
                description:
                    "Niveau 2 — Prospection, signature et accompagnement de réseaux B2B avec commission récurrente.",
            },
            {
                "@type": "Offer",
                name: "Master Partner",
                description:
                    "Niveau 3 — Opération d'une zone géographique ou d'un vertical entier avec override.",
            },
        ],
    };

    const breadcrumbSchema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
            {
                "@type": "ListItem",
                position: 1,
                name: "Accueil",
                item: "https://capdistrib.com/",
            },
            {
                "@type": "ListItem",
                position: 2,
                name: "Programme partenaire",
                item: "https://capdistrib.com/#programme",
            },
            {
                "@type": "ListItem",
                position: 3,
                name: "Rejoindre",
                item: "https://capdistrib.com/#rejoindre",
            },
        ],
    };

    return (
        <>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
            />
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify(serviceSchema),
                }}
            />
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify(breadcrumbSchema),
                }}
            />
        </>
    );
}
